export const pools = {
  state: null,
  reducers: {
    update: (state, payload) => {
      return payload;
    },
  },
};
